import { toHearingPhoneMatchKey } from './hearingPhoneMatch';

import type {
  CallHearingState,
  HearingPhone,
} from 'features/call/call-hearing/interfaces';
import { HearingParticipantType } from 'features/call/call-hearing/interfaces';

// Resolve the hearing row a status/id update should mutate.
// Prefer an exact participant id match; otherwise choose the newest live row for
// the phone number, then the primary row, then the first remaining match.
// Blocked-CID inbound H2D stays "anonymous" for the life of the call.
export const resolveHearingByIdOrPhone = ({
  state,
  phoneNumber,
  id,
}: {
  state: CallHearingState;
  phoneNumber: HearingPhone;
  id: string;
}) => {
  if (id) {
    const hearingById = state.hearings.find((hearing) => hearing.id === id);
    if (hearingById) {
      return hearingById;
    }
  }

  const normalizedPhoneNumber = toHearingPhoneMatchKey(phoneNumber);
  const matchingHearings = state.hearings.filter(
    (hearing) =>
      toHearingPhoneMatchKey(hearing.phoneNumber) === normalizedPhoneNumber
  );

  if (!matchingHearings.length) {
    throw new Error(`Hearing (${phoneNumber}) not found`);
  }

  const liveHearing = matchingHearings.findLast(
    (hearing) => hearing.status !== 'disconnected'
  );
  if (liveHearing) {
    return liveHearing;
  }

  const primaryHearing = matchingHearings.find(
    (hearing) => hearing.type === HearingParticipantType.PRIMARY
  );
  if (primaryHearing) {
    return primaryHearing;
  }

  return matchingHearings[0];
};
